import { round } from '../../helpers';

export default diet =>
  round(
    diet
      .map(ingredient => ({
        weightedEfValue: (ingredient.percentage / 100) * ingredient.efValue,
        ...ingredient,
      }))
      .reduce((prev, cur) => prev + cur.weightedEfValue, 0),
    2
  );
